// extracted by mini-css-extract-plugin
export default {"root":"PriceInputs_root__R3ouZ","input":"PriceInputs_input__+SXw+","separator":"PriceInputs_separator__Nr1Iz"};